import { useSelector } from "react-redux";

import { Button, Heading, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { LandingPages } from "constants/landing-pages";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { useConnectOpenWidget } from "hooks/settings/openwidget/use-connect-openwidget";
import { selectIsAdmin } from "store/entities/agents";

import ContentWrapper from "./components/ContentWrapper";
import { NonAdminAlert } from "./components/NonAdminAlert";
import { OpenWidgetPromoVideo } from "./components/OpenWidgetPromoVideo";
import { trackLearnMoreClicked } from "./helpers";
import { textAlignCenterStyles } from "./styles";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const NotInOrganization = () => {
  const { mutate: connectOpenWidget, isLoading: isConnecting } = useConnectOpenWidget();
  const isOwner = useSelector(selectIsAdmin);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const onConnectOpenWidget = () => {
    connectOpenWidget();
    trackEngagement("OpenWidget: Connected", EventPlace.Settings, { inOrganization: false });
  };

  return (
    <ContentWrapper center>
      <Flex column maxWidth="560px" gap="16px" alignItems="center">
        <Heading css={textAlignCenterStyles}>Play with forms with a modern twist</Heading>
        <Text css={textAlignCenterStyles}>
          Add a responsive and seamlessly integrable contact widget to be more accessible. Allow your visitors to submit
          forms for diverse goals through the attention-grabbing widget installed on your website.
        </Text>
        <Flex gap="24px" flexWrap justifyContent="center">
          <Button
            kind="primary"
            onClick={onConnectOpenWidget}
            loading={isConnecting}
            disabled={!isOwner}
            data-testid="connect-button"
          >
            Create contact widget
          </Button>
          <Button
            kind="link"
            href={LandingPages.OpenWidget}
            target="_blank"
            onClick={() => trackLearnMoreClicked("not-in-organization")}
            data-testid="no-ow-learn-more-button"
          >
            Learn more
          </Button>
        </Flex>
      </Flex>
      {!isOwner && <NonAdminAlert />}
      <OpenWidgetPromoVideo />
    </ContentWrapper>
  );
};
